export default "__VITE_ASSET__C0HZbAR7__"